module.exports = __webpack_public_path__ + "static/img/title@2x.98f152de.png";